import React, { lazy, Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import { FullCoverLoading } from '../components';
const AnyAuth = lazy(() => import('../AnyAuth'));
// ツール
const ToolTop = lazy(() => import('../Pages/Tool/Top').then(({ Top }) => ({ default: Top })));
const ToolLength = lazy(() => import('../Pages/Tool/Length').then(({ Length }) => ({ default: Length })));
const ToolPipeCutLength = lazy(() => import('../Pages/Tool/PipeCutLength').then(({ PipeCutLength }) => ({ default: PipeCutLength })));
const ToolFlangeCheet = lazy(() => import('../Pages/Tool/FlangeCheet').then(({ FlangeCheet }) => ({ default: FlangeCheet })));
const ToolTriFunc = lazy(() => import('../Pages/Tool/TriFunc').then(({ TriFunc }) => ({ default: TriFunc })));
const ToolSymbol = lazy(() => import('../Pages/Tool/Symbol').then(({ Symbol }) => ({ default: Symbol })));
const ToolSGP = lazy(() => import('../Pages/Tool/SGP').then(({ SGP }) => ({ default: SGP })));
const ToolPipeConnectCheet = lazy(() => import('../Pages/Tool/PipeConnectCheet').then(({ PipeConnectCheet }) => ({ default: PipeConnectCheet })));
const ToolRouter = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: React.createElement(FullCoverLoading, null) },
            React.createElement(Switch, null,
                React.createElement(Route, { exact: true, path: "/tool/top", component: ToolTop }),
                React.createElement(Route, { exact: true, path: "/tool/length", component: ToolLength }),
                React.createElement(Route, { exact: true, path: "/tool/pipecutlength", component: ToolPipeCutLength }),
                React.createElement(Route, { exact: true, path: "/tool/trifunc", component: ToolTriFunc }),
                React.createElement(Route, { exact: true, path: "/tool/flangecheet", component: ToolFlangeCheet }),
                React.createElement(Route, { exact: true, path: "/tool/pipeconnectcheet", component: ToolPipeConnectCheet }),
                React.createElement(Route, { exact: true, path: "/tool/symbol", component: ToolSymbol }),
                React.createElement(Route, { exact: true, path: "/tool/sgp", component: ToolSGP })))));
};
export default ToolRouter;
